<template>
    <div
        v-if="!tokenLoading"
        class="set-password"
    >
        <img
            src="/images/logo.png"
            alt="goTenna Pro Management Portal"
            class="logo"
        />

        <div
            v-if="passwordSet"
            class="copy success"
        >
            <p class="mb-60">
                You've successfully confirmed your account and can now log in to the goTenna Pro app, ATAK plugin, and
                Pro Management Portal!
            </p>

            <router-link
                class="btn btn-primary"
                tag="button"
                to="/login"
            >
                Proceed to Portal
            </router-link>
        </div>

        <p
            v-if="!tokenValid"
            class="copy success"
        >
            Sorry, this link has already been used or is invalid. Please contact your organization administrator.
        </p>

        <form
            v-if="tokenValid && !passwordSet"
            @submit.prevent="setPassword"
        >
            <p class="copy">Set a password for your field user account:</p>

            <div class="form-group">
                <label for="password">Password</label>
                <input
                    id="password"
                    v-model="password"
                    type="password"
                    required
                    maxlength="255"
                />
            </div>

            <div class="form-group">
                <label for="password_confirmation">Confirm Password</label>
                <input
                    id="password_confirmation"
                    v-model="passwordConfirmation"
                    type="password"
                    required
                    maxlength="255"
                />
            </div>

            <form-errors :response="errorResponse"></form-errors>

            <div class="form-group">
                <button
                    type="submit"
                    class="btn"
                >
                    Submit
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'

export default {
    components: {
        FormErrors,
    },

    props: ['token'],

    data() {
        return {
            password: null,
            passwordConfirmation: null,
            passwordSet: false,
            tokenValid: false,
            tokenLoading: true,
            errorResponse: null,
        }
    },

    mounted() {
        this.$http
            .get(`onboarding/field-user/${this.token}/set-password`)
            .then(() => {
                this.tokenValid = true
            })
            .catch(() => {
                this.tokenValid = false
            })
            .finally(() => {
                this.tokenLoading = false
            })
    },

    methods: {
        setPassword() {
            this.$http
                .post(`onboarding/field-user/${this.token}/set-password`, {
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                })
                .then(({ data }) => {
                    this.passwordSet = true
                })
                .catch((error) => {
                    if (error.response.status === 404) {
                        this.tokenValid = false
                    } else {
                        this.errorResponse = error.response
                    }
                })
        },
    },
}
</script>
